module.exports = __webpack_public_path__ + "media/images/sample/product-7-65502d71cb4cc4b95dcfd7cf93e0e139.png";